import DesCollabEditTeamViewModel from 'viewmodel/DesCollabEditTeamViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesCollabEditTeam extends DesBaseCatalogAcc {
    constructor() {
        super(DesCollabEditTeamViewModel);
    }

    get locale() {
        return this.getAttribute('locale') || 'en_US';
    }

    get collaborationspaceid() {
        return this.getAttribute('collaborationspaceid');
    }

    get teamId() {
        return this.getAttribute('team-id') || this.getAttribute('teamid');
    }

    getProps() {
        return {
            collaborationspaceid: this.collaborationspaceid,
            teamid: this.teamId
        };
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'collaborationspaceid', 'team-id', 'locale', 'teamid'];
    }
}

if (!window.customElements.get('des-collab-edit-team')) {
    window.customElements.define('des-collab-edit-team', DesCollabEditTeam);
}
